import React, { useState, useRef, useEffect } from "react";
import styles from "./AddCreditModal.module.css";
// import FetchWithToken from "../FetchWithToken/FetchWithToken";
import { apiUrl } from "../../Constants/Constants";
import { AuthContext } from "../../Constants/AuthProvider";
import { useFetchWithToken } from "./../FetchWithToken/FetchWithToken";
import Loading from "./../Loading/Loading.module";
import { toast } from "react-toastify";
import CtaBtns from "../CtaBtns/CtaBtns.module";
import { form } from "framer-motion/client";
const AddCreditModal = ({ isOpen, onClose, onAddCredit, loadingShow }) => {
  const { loading, fetchWithToken } = useFetchWithToken();
  const { onLogout } = React.useContext(AuthContext);
  const [amount, setAmount] = useState("");
  const formToSubmit = useRef(null);

  // فرمت عدد با جداکننده سه‌تایی
  const formatNumber = (num) => {
    if (!num) return "";
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  // تبدیل عدد به متن تومان
  const toText = (num) => {
    if (!num || isNaN(num)) return "";

    const ones = [
      "",
      "یک",
      "دو",
      "سه",
      "چهار",
      "پنج",
      "شش",
      "هفت",
      "هشت",
      "نه",
    ];
    const tens = [
      "",
      "ده",
      "بیست",
      "سی",
      "چهل",
      "پنجاه",
      "شصت",
      "هفتاد",
      "هشتاد",
      "نود",
    ];
    const teens = [
      "ده",
      "یازده",
      "دوازده",
      "سیزده",
      "چهارده",
      "پانزده",
      "شانزده",
      "هفده",
      "هجده",
      "نوزده",
    ];
    const hundreds = [
      "",
      "یکصد",
      "دویست",
      "سیصد",
      "چهارصد",
      "پانصد",
      "ششصد",
      "هفتصد",
      "هشتصد",
      "نهصد",
    ];
    const scales = ["", "هزار", "میلیون", "میلیارد"];

    const chunkToWords = (chunk) => {
      let chunkWords = [];
      const hundred = Math.floor(chunk / 100);
      const remainder = chunk % 100;

      if (hundred > 0) chunkWords.push(hundreds[hundred]);

      if (remainder >= 10 && remainder < 20) {
        chunkWords.push(teens[remainder - 10]);
      } else {
        const ten = Math.floor(remainder / 10);
        const one = remainder % 10;

        if (ten > 0) chunkWords.push(tens[ten]);
        if (one > 0) chunkWords.push(ones[one]);
      }

      return chunkWords.join(" و ");
    };

    const chunks = [];
    let scaleIndex = 0;

    while (num > 0) {
      const chunk = num % 1000;
      num = Math.floor(num / 1000);

      if (chunk > 0) {
        chunks.push(
          chunkToWords(chunk) +
            (scales[scaleIndex] ? ` ${scales[scaleIndex]}` : "")
        );
      }
      scaleIndex++;
    }

    return chunks.reverse().join(" و ");
  };

  const handleInputChange = (e) => {
    const rawValue = e.target.value.replace(/,/g, ""); // حذف جداکننده‌ها
    if (/^\d*$/.test(rawValue)) {
      setAmount(rawValue);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const rawAmount = amount.replace(/,/g, ""); // حذف جداکننده‌ها
    if (
      rawAmount &&
      parseInt(rawAmount) > 10000 &&
      parseInt(rawAmount) < 5000000
    ) {
      const former = new FormData();
      former.append("amount", parseInt(rawAmount));

      fetchWithToken(
        apiUrl + "user/import-wallet",
        {
          method: "POST",
        },
        former
      ).then((data) => {
        if (data.status === "200") {
          toast.info("در حال انتقال به دروازه پرداخت...");
          window.location.replace(data.data);
        }

        if (data.status === "401") {
          loadingShow(false);
          onLogout();
        }
      });
      setAmount("");
      onClose();
    } else {
      toast.error("لطفا یک مبلغ معتبر وارد نمایید!");
    }
  };

  useEffect(() => {
    if (loading === true) {
      loadingShow(loading);
    }
  }, [loading]);
  if (!isOpen) return null;

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <div className={styles.topBoxIcons}>
          <div className={styles.rightIconTop}>
            <i class="fa-solid fa-plus"></i>
          </div>
          <button className={styles.custommodalclose} onClick={() => onClose()}>
            ×
          </button>
        </div>
        <div className={styles.title}>افـــزایش اعتبــــار</div>
        <form
          ref={formToSubmit}
          onSubmit={handleSubmit}
          className={styles.form}
        >
          <label htmlFor="amount" className={styles.label}>
            مبلغ مورد نظر را وارد کنید (تومان):
          </label>
          <div className={styles.boxOfIn}>
            <input
              id="amount"
              type="tel"
              placeholder="مثال: 50000"
              className={styles.input}
              value={formatNumber(amount)} // نمایش عدد با جداکننده‌ها
              onChange={handleInputChange}
            />
            <div className={styles.border}></div>
          </div>
          {amount && (
            <p className={styles.textAmount}>
              {toText(Number(amount.replace(/,/g, "")))} تومان
            </p>
          )}

          <CtaBtns onAtion={() => formToSubmit.current.requestSubmit()}>
            پرداخت و افزایش اعتبار
          </CtaBtns>
        </form>
      </div>
    </div>
  );
};

export default AddCreditModal;
